import React, { useContext, useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import moment from "moment"
import { MdCreateNewFolder, MdRefresh, MdCheck, MdBuild } from "react-icons/md";

import {FirebaseContext} from '../services/Firebase/Context'

const ActivityItem = ({ data: { createdAt, action, recordId, type, userId }}) => {
  const { db } = useContext(FirebaseContext)
  const [user, setUser] = useState({})
  const [record, setRecord] = useState({})

  useEffect(() => {
    const userSub = onSnapshot(doc(db, "users", userId), (doc) => setUser({id: doc.id, ...doc.data()}));
    const recordSub = onSnapshot(doc(db, "records", recordId), (doc) => setRecord({id: doc.id, ...doc.data()}));
    return () => {
      userSub()
      recordSub()
    }
  }, [db, userId, recordId])

  return (
    <div className="flex items-start mb-6 rounded justify-between">
        { type === "step" && action === "new"
          && <span className="rounded-full text-white dark:text-gray-800 p-2 bg-red-300"><MdBuild /></span>
        }
        { type === "record" && action === "new"
          && <span className="rounded-full text-white dark:text-gray-800 p-2 bg-yellow-300"><MdCreateNewFolder /></span>
        }
        { type === "record" && action === "update"
          && <span className="rounded-full text-white dark:text-gray-800 p-2 bg-blue-300"><MdRefresh /></span>
        }
        { type === "record" && action === "end"
          && <span className="rounded-full text-white dark:text-gray-800 p-2 bg-green-300"><MdCheck /></span>
        }
      <div className="flex items-center w-full justify-between">
        <div className="flex text-sm flex-col w-full ml-2 items-start justify-between">
          <p className="text-gray-700 dark:text-white">
            <span className="font-bold mr-1">
              {user && user.firstName} {user && user.lastName && user.lastName.charAt(0)}
            </span>
            { type === "record" && action === "new" && 'a crée un nouveau dossier pour '}
            { type === "record" && action === "update" && 'a modifié le dossier de '}
            { type === "record" && action === "end" && 'a clôturé le dossier de '}
            { type === "step" && action === "new" && 'a ajouté un événement au dossier de '}
            <span className="font-bold mr-1">
              {record.customerName}{ record.customerBusiness && <span className='ml-1 text-yellow-600'>Pro</span> }
              <small className='ml-1'>({record.numberPlate})</small>
            </span>
          </p>
          <p className="text-gray-300">
            {createdAt && moment(createdAt.toDate()).calendar()}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ActivityItem